import throttle from 'lodash/throttle';
import { isDesktop } from 'react-device-detect';

const ExitIntent = (options = {}) => {
  const defaultOptions = {
    threshold: 20,
    maxDisplays: 1,
    eventThrottle: 200,
    minTimeOnPage: 10,
    timestamp: Date.now(),
    onExitIntent: () => {},
  };

  return (() => {
    const config = { ...defaultOptions, ...options };
    const eventListeners = new Map();
    let displays = 0;

    const addEvent = (eventName, callback) => {
      document.addEventListener(eventName, callback, false);
      eventListeners.set(`document:${eventName}`, { eventName, callback });
    };

    const removeEvent = (key) => {
      const { eventName, callback } = eventListeners.get(key);
      document.removeEventListener(eventName, callback);
      eventListeners.delete(key);
    };

    const shouldDisplay = (position) => {
      const timeOnPage = (Date.now() - config.timestamp) / 1000;
      if (
        !document.cookie
          .split('; ')
          .find((row) => row.startsWith('modal_seen')) &&
        isDesktop &&
        position <= config.threshold &&
        displays < config.maxDisplays &&
        timeOnPage > config.minTimeOnPage
      ) {
        // eslint-disable-next-line no-plusplus
        displays++;
        return true;
      }

      return false;
    };

    const removeEvents = () => {
      eventListeners.forEach((value, key) => removeEvent(key));
    };

    const mouseDidMove = (event) => {
      if (shouldDisplay(event.clientY)) {
        config.onExitIntent();
        if (displays >= config.maxDisplays) {
          removeEvents();
        }
      }
    };

    addEvent('mousemove', throttle(mouseDidMove, config.eventThrottle));

    return removeEvents;
  })();
};

export default ExitIntent;
